import React, { useEffect } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { ValidatedField, ValidatedForm, isNumber } from 'react-jhipster';
import { Link, useNavigate, useParams } from 'react-router';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getEntities as getClientes } from 'app/entities/cliente/cliente.reducer';
import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';

import { createEntity, getEntity, reset, updateEntity } from './mensaje.reducer';

export const MensajeUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const clientes = useAppSelector(state => state.cliente.entities);
  const mensajeEntity = useAppSelector(state => state.mensaje.entity);
  const loading = useAppSelector(state => state.mensaje.loading);
  const updating = useAppSelector(state => state.mensaje.updating);
  const updateSuccess = useAppSelector(state => state.mensaje.updateSuccess);

  const handleClose = () => {
    navigate(`/mensaje${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getClientes({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.id !== undefined && typeof values.id !== 'number') {
      values.id = Number(values.id);
    }
    if (values.referencia !== undefined && typeof values.referencia !== 'number') {
      values.referencia = Number(values.referencia);
    }
    if (values.monto !== undefined && typeof values.monto !== 'number') {
      values.monto = Number(values.monto);
    }
    values.timestampLimite = convertDateTimeToServer(values.timestampLimite);
    values.timestampSolicitud = convertDateTimeToServer(values.timestampSolicitud);
    if (values.edoPet !== undefined && typeof values.edoPet !== 'number') {
      values.edoPet = Number(values.edoPet);
    }
    values.createdDate = convertDateTimeToServer(values.createdDate);
    values.lastModifiedDate = convertDateTimeToServer(values.lastModifiedDate);

    const entity = {
      ...mensajeEntity,
      ...values,
      cliente: clientes.find(it => it.id.toString() === values.cliente?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {
          timestampLimite: displayDefaultDateTime(),
          timestampSolicitud: displayDefaultDateTime(),
          createdDate: displayDefaultDateTime(),
          lastModifiedDate: displayDefaultDateTime(),
        }
      : {
          ...mensajeEntity,
          timestampLimite: convertDateTimeFromServer(mensajeEntity.timestampLimite),
          timestampSolicitud: convertDateTimeFromServer(mensajeEntity.timestampSolicitud),
          createdDate: convertDateTimeFromServer(mensajeEntity.createdDate),
          lastModifiedDate: convertDateTimeFromServer(mensajeEntity.lastModifiedDate),
          cliente: mensajeEntity?.cliente?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tupago1App.mensaje.home.createOrEditLabel" data-cy="MensajeCreateUpdateHeading">
            Create or edit a Mensaje
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew && <ValidatedField name="id" required readOnly id="mensaje-id" label="ID" validate={{ required: true }} />}
              <ValidatedField
                label="Nombre Cliente"
                id="mensaje-nombreCliente"
                name="nombreCliente"
                data-cy="nombreCliente"
                type="text"
                validate={{
                  maxLength: { value: 40, message: 'This field cannot be longer than 40 characters.' },
                }}
              />
              <ValidatedField
                label="Numero Celular"
                id="mensaje-numeroCelular"
                name="numeroCelular"
                data-cy="numeroCelular"
                type="text"
                validate={{
                  minLength: { value: 10, message: 'This field is required to be at least 10 characters.' },
                  maxLength: { value: 10, message: 'This field cannot be longer than 10 characters.' },
                }}
              />
              <ValidatedField
                label="Referencia"
                id="mensaje-referencia"
                name="referencia"
                data-cy="referencia"
                type="text"
                validate={{
                  required: { value: true, message: 'This field is required.' },
                  validate: v => isNumber(v) || 'This field should be a number.',
                }}
              />
              <ValidatedField
                label="Concepto"
                id="mensaje-concepto"
                name="concepto"
                data-cy="concepto"
                type="text"
                validate={{
                  required: { value: true, message: 'This field is required.' },
                  maxLength: { value: 100, message: 'This field cannot be longer than 100 characters.' },
                }}
              />
              <ValidatedField
                label="Monto"
                id="mensaje-monto"
                name="monto"
                data-cy="monto"
                type="text"
                validate={{
                  required: { value: true, message: 'This field is required.' },
                  validate: v => isNumber(v) || 'This field should be a number.',
                }}
              />
              <ValidatedField
                label="Timestamp Limite"
                id="mensaje-timestampLimite"
                name="timestampLimite"
                data-cy="timestampLimite"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label="Timestamp Solicitud"
                id="mensaje-timestampSolicitud"
                name="timestampSolicitud"
                data-cy="timestampSolicitud"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
                validate={{
                  required: { value: true, message: 'This field is required.' },
                }}
              />
              <ValidatedField
                label="Id Mensaje Cobro"
                id="mensaje-idMensajeCobro"
                name="idMensajeCobro"
                data-cy="idMensajeCobro"
                type="text"
                validate={{
                  maxLength: { value: 50, message: 'This field cannot be longer than 50 characters.' },
                }}
              />
              <ValidatedField label="Edo Pet" id="mensaje-edoPet" name="edoPet" data-cy="edoPet" type="text" />
              <ValidatedField
                label="Extra 1"
                id="mensaje-extra1"
                name="extra1"
                data-cy="extra1"
                type="text"
                validate={{
                  maxLength: { value: 50, message: 'This field cannot be longer than 50 characters.' },
                }}
              />
              <ValidatedField
                label="Extra 2"
                id="mensaje-extra2"
                name="extra2"
                data-cy="extra2"
                type="text"
                validate={{
                  maxLength: { value: 50, message: 'This field cannot be longer than 50 characters.' },
                }}
              />
              <ValidatedField
                label="Extra 3"
                id="mensaje-extra3"
                name="extra3"
                data-cy="extra3"
                type="text"
                validate={{
                  maxLength: { value: 750, message: 'This field cannot be longer than 750 characters.' },
                }}
              />
              <ValidatedField
                label="Extra 4"
                id="mensaje-extra4"
                name="extra4"
                data-cy="extra4"
                type="text"
                validate={{
                  maxLength: { value: 500, message: 'This field cannot be longer than 500 characters.' },
                }}
              />
              <ValidatedField
                label="Extra 5"
                id="mensaje-extra5"
                name="extra5"
                data-cy="extra5"
                type="text"
                validate={{
                  maxLength: { value: 50, message: 'This field cannot be longer than 50 characters.' },
                }}
              />
              <ValidatedField
                label="Extra 6"
                id="mensaje-extra6"
                name="extra6"
                data-cy="extra6"
                type="text"
                validate={{
                  maxLength: { value: 50, message: 'This field cannot be longer than 50 characters.' },
                }}
              />
              <ValidatedField
                label="Extra 7"
                id="mensaje-extra7"
                name="extra7"
                data-cy="extra7"
                type="text"
                validate={{
                  maxLength: { value: 50, message: 'This field cannot be longer than 50 characters.' },
                }}
              />
              <ValidatedField
                label="Extra 8"
                id="mensaje-extra8"
                name="extra8"
                data-cy="extra8"
                type="text"
                validate={{
                  maxLength: { value: 50, message: 'This field cannot be longer than 50 characters.' },
                }}
              />
              <ValidatedField
                label="Extra 9"
                id="mensaje-extra9"
                name="extra9"
                data-cy="extra9"
                type="text"
                validate={{
                  maxLength: { value: 50, message: 'This field cannot be longer than 50 characters.' },
                }}
              />
              <ValidatedField
                label="Extra 10"
                id="mensaje-extra10"
                name="extra10"
                data-cy="extra10"
                type="text"
                validate={{
                  maxLength: { value: 50, message: 'This field cannot be longer than 50 characters.' },
                }}
              />
              <ValidatedField
                label="Created By"
                id="mensaje-createdBy"
                name="createdBy"
                data-cy="createdBy"
                type="text"
                validate={{
                  maxLength: { value: 50, message: 'This field cannot be longer than 50 characters.' },
                }}
              />
              <ValidatedField
                label="Created Date"
                id="mensaje-createdDate"
                name="createdDate"
                data-cy="createdDate"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label="Last Modified By"
                id="mensaje-lastModifiedBy"
                name="lastModifiedBy"
                data-cy="lastModifiedBy"
                type="text"
                validate={{
                  maxLength: { value: 50, message: 'This field cannot be longer than 50 characters.' },
                }}
              />
              <ValidatedField
                label="Last Modified Date"
                id="mensaje-lastModifiedDate"
                name="lastModifiedDate"
                data-cy="lastModifiedDate"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField id="mensaje-cliente" name="cliente" data-cy="cliente" label="Cliente" type="select">
                <option value="" key="0" />
                {clientes
                  ? clientes.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.nombre}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button as={Link as any} id="cancel-save" data-cy="entityCreateCancelButton" to="/mensaje" replace variant="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">Back</span>
              </Button>
              &nbsp;
              <Button variant="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp; Save
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default MensajeUpdate;
